import { render, staticRenderFns } from "./CardTemplate.vue?vue&type=template&id=75cc248c&scoped=true"
import script from "./CardTemplate.vue?vue&type=script&lang=js"
export * from "./CardTemplate.vue?vue&type=script&lang=js"
import style0 from "./CardTemplate.vue?vue&type=style&index=0&id=75cc248c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cc248c",
  null
  
)

export default component.exports